export const interiorsSelector = (state) => state.interiors.interiors.items;
export const interiorsCountsSelector = (state) => state.interiors.counts;

export const selectSelectedSorting = (state) => state.interiors.sorting;
export const selectInteriorScenes = (state) => state.interiors.scenes;

